import 'reflect-metadata';

import { environment } from '../environments/environment';

import { platformBrowser } from '@angular/platform-browser';
import { AppModule } from './app.module';
import { enableProdMode } from '@angular/core';

if (environment.production) {
  enableProdMode();
}

void platformBrowser().bootstrapModule(AppModule);
